import { api, ApiRequestConfig } from './api';
import { FetchModelProps, GetModelData } from '../types/model';

export const PDP_PATH_NAME = '/product/';
export const TYP_PATH_NAME = '/checkout/success/';
export const LK_ORDER_DETAILS_PATH_NAME = '/lk/history/orders-details/';
export const LK_RECEIPT_DETAILS_PATH_NAME = '/lk/history/receipt-details/';
export const BRANDS_LIST_PATH_NAME = '/brandslist';
export const BRANDS_PATH_NAME = '/brands';
export const OTZYVY_PAGE_NAME = 'otzyvy';
export const OTZYVY_PATH_NAME = `/${OTZYVY_PAGE_NAME}`;
export const GET_MODEL_V2_URL = 'v2/get-model';
export const GET_MODEL_URL = 'getModel';

export const TRUNCATE_PARAMS_PAGE_LIST = [
  TYP_PATH_NAME,
  LK_ORDER_DETAILS_PATH_NAME,
  LK_RECEIPT_DETAILS_PATH_NAME,
];

export const getModel = (params: FetchModelProps, config: ApiRequestConfig) => {
  const truncateParamsPage = TRUNCATE_PARAMS_PAGE_LIST.find(page => params.pathname.includes(page));
  const preparedParams = truncateParamsPage ? { ...params, pathname: truncateParamsPage } : params;
  const { pathname } = preparedParams;

  if (pathname.includes(OTZYVY_PATH_NAME)) {
    preparedParams.pathname = `${PDP_PATH_NAME}${OTZYVY_PAGE_NAME}`;
  }

  const url =
    pathname.includes(PDP_PATH_NAME) && !pathname.includes(OTZYVY_PATH_NAME)
      ? GET_MODEL_V2_URL
      : GET_MODEL_URL;

  return api.get<GetModelData>(url, preparedParams, config);
};
